export default __webpack_public_path__ + "media/titles/title_4_locale_en-af4ba1c0.png";